import { JobRelatedInfoResponse } from '@doda/api-client/aspida/@types';
import { FC, useEffect, useRef } from 'react';
import { ListItem } from '../ListItem';
import { ToggleButton } from '../ToggleButton';
import styles from './index.module.scss';

/** 13件以上のときアコーディオンになる */
const INITIAL_SHOW_COUNT = 13;

interface Props {
  relationInfoList: JobRelatedInfoResponse[];
  handleFetchPaginate: () => void;
  isFetchedAllInfoList: boolean;
  isOpen: boolean;
  toggle: () => void;
}

/**
 * 関連情報リスト
 * @param relationInfoList 関連情報リスト
 * @param handleFetchPaginate 追加読み込みハンドラ
 * @param isFetchedAllInfoList すべて取得完了フラグ
 * @param isOpen アコーディオンの開閉フラグ
 * @param toggle アコーディオンの開閉フラグ変更ハンドラ
 */
export const RelationInformationList: FC<Props> = ({
  relationInfoList,
  handleFetchPaginate,
  isFetchedAllInfoList,
  isOpen,
  toggle,
}) => {
  const isVisibleToggleButton = relationInfoList.length >= INITIAL_SHOW_COUNT;
  const contentRef = useRef<HTMLUListElement>(null);
  const contentHeight = useRef<{ default: number; max: number }>({
    default: 0,
    max: 0,
  });

  /** アコーディオン開閉 */
  const handleAccordionHeight = () => {
    if (!contentRef.current) return;
    if (isOpen) {
      contentRef.current.style.maxHeight = `${contentHeight.current.default}px`;
    } else {
      contentRef.current.style.maxHeight = `${contentHeight.current.max}px`;
    }
    toggle();
  };

  const handleClickToggleButton: React.MouseEventHandler<
    HTMLButtonElement
  > = () => {
    if (isFetchedAllInfoList) {
      // 全求人取得済みのときはアコーディオン開閉
      handleAccordionHeight();
    } else {
      // 未取得求人ありのときは追加読み込み
      handleFetchPaginate();
    }
  };

  // 初期状態の要素の高さを取得
  useEffect(() => {
    if (contentRef.current) {
      const height = contentRef.current.scrollHeight;
      contentHeight.current.default = height;
      contentRef.current.style.maxHeight = `${height}px`; // transitionを効かせるためmaxHeightを指定する
    }
  }, []);

  // 要素数増加後の高さを取得
  useEffect(() => {
    if (contentRef.current) {
      const height = contentRef.current.scrollHeight;
      contentHeight.current.max = height;
      contentRef.current.style.maxHeight = `${height}px`;
    }
  }, [relationInfoList.length]);

  return (
    <>
      <ul
        className={styles['jobSearchDetail-relationInformationList']}
        ref={contentRef}
      >
        {relationInfoList.map(({ url, text, isDeadline, isNew }) => (
          <ListItem
            key={url}
            url={url}
            text={text}
            isDeadline={isDeadline}
            isNew={isNew}
          />
        ))}
      </ul>
      {isVisibleToggleButton && (
        <ToggleButton onClick={handleClickToggleButton} isOpen={isOpen} />
      )}
    </>
  );
};
